import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { CheckOutlined, DeleteOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { formatDateTime } from '../../../../utils/functions';
import CommonTable from '../../../global/table';
import CommonCardView from '../../../global/cardView';
import NoRecordFound from '../../../global/noRecordFound';
import CommonDrawer from '../../../global/drawer';
import CommonDialog from '../../../global/dialog';
import EnhancedLeadsImportedViaFormCardView from './EnhancedLeadsImportedViaFormCardView';
import EnhancedLeadsImportedViaFormDetails from './EnhancedLeadsImportedViaFormDetails';

const EnhancedLeadsImportedViaFormList = ({
    isLoading,
    leadsImported,
    sort,
    setSort,
    viewType,
    handleAcceptReject,
    leadAcceptMutation
}) => {
    const [leadDetails, setLeadDetails] = useState({
        show: false,
        data: null
    });

    const [toggleModal, setToggleModal] = useState({
        show: false,
        type: "",
        id: null
    });

    const onActionConfirm = async (type) => {
        if (toggleModal.id) {
            await handleAcceptReject(toggleModal.id, type);
            setToggleModal({ show: false, type: "", id: null });
        }
    };

    const actions = [
        {
            label: "Accept",
            icon: <CheckOutlined />,
            onClick: (record) => setToggleModal({ show: true, type: "ACCEPT", id: record.id }),
            className: "!text-primary !border-primary hover:!border-primary hover:!bg-primary hover:!text-white"
        },
        {
            label: "Reject",
            icon: <DeleteOutlined />,
            onClick: (record) => setToggleModal({ show: true, type: "REJECT", id: record.id }),
            className: "border !border-red-500 !text-red-500 hover:!bg-red-500 hover:!text-white border-none hover:!border-none"
        }
    ];

    // Columns Configuration
    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            sortType: "Name",
            isAvatar: true,
            render: (text, record) => (
                <div
                    className="cursor-pointer hover:text-primary font-medium"
                    onClick={() => setLeadDetails({ show: true, data: record.originalData })}
                >
                    {text}
                </div>
            )
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            sortType: "Email",
            render: (text) => (
                <p className='!text-primary'>{text}</p>
            )
        },
        {
            title: "Phone",
            dataIndex: "phone",
            key: "phone",
            sortType: "Phone",
        },
        {
            title: "Event Name",
            dataIndex: "eventName",
            key: "eventName",
            sortType: "Event Name",
        },
        {
            title: "Imported At",
            dataIndex: "importedAt",
            key: "importedAt",
            sortType: "Imported At",
        }
    ];

    // Data Mapping
    const data = Array.isArray(leadsImported) && leadsImported.length > 0
        ? leadsImported.map((item) => ({
            key: item._id,
            id: item._id,
            name: item.fullName ? item.fullName : `${item?.firstName} ${item?.lastName}`,
            email: item?.email,
            phone: item?.phone,
            eventName: item?.eventName,
            eventType: item?.eventType,
            eventDate: item?.eventDate,
            guestCount: item?.guestCount,
            company: item?.company,
            importedAt: formatDateTime(item?.dateAsPerUserTimezone),
            originalData: { ...item }
        }))
        : [];


    return (
        <>
            {data.length > 0 ? (
                <>
                    {viewType === "LIST" ? (
                        <CommonTable
                            columns={columns}
                            data={data}
                            sort={sort}
                            setSort={setSort}
                            onRowClick={(record) => setLeadDetails({ show: true, data: record.originalData })}
                            isLoading={isLoading}
                            showActions={true}
                            actions={actions}
                        />
                    ) : (
                        <CommonCardView>
                            {data.map((record) => (
                                <EnhancedLeadsImportedViaFormCardView
                                    key={record.id}
                                    record={record}
                                    onCardClick={(record) => setLeadDetails({ show: true, data: record.originalData })}
                                    actions={actions}
                                />
                            ))}
                        </CommonCardView>
                    )}
                </>
            ) : (
                <NoRecordFound message="No leads imported found." />
            )}

            {toggleModal.show && (
                <CommonDialog
                    title={toggleModal.type === "ACCEPT" ? "Accept Lead" : "Reject Lead"}
                    description={
                        toggleModal.type === "ACCEPT"
                            ? "Are you sure you want to accept this lead?"
                            : "Are you sure you want to reject this lead? This action cannot be undone."
                    }
                    open={toggleModal.show}
                    setOpen={() => setToggleModal({ show: false, type: "", id: null })}
                    onOk={() => onActionConfirm(toggleModal.type)}
                    onCancel={() => setToggleModal({ show: false, type: "", id: null })}
                    isConfirmButtonLoading={leadAcceptMutation.isPending}
                />
            )}

            {
                leadDetails.show && (
                    <CommonDrawer
                        open={leadDetails.show}
                        setOpen={() => setLeadDetails({ show: false, data: null })}
                        title="Lead Details"
                        width={"800px"}
                        children={
                            <EnhancedLeadsImportedViaFormDetails
                                leadDetail={leadDetails.data}
                                handleAcceptReject={handleAcceptReject}
                            />
                        }
                    />
                )
            }
        </>
    );
};

export default EnhancedLeadsImportedViaFormList;
